import PrimaryButton from "@/components/common/buttons/primary-button/PrimaryButton";
import styles from "./not-found-page.module.scss";
import { useTranslation } from "react-i18next";
import { HOME_ROUTE, LOGIN_ROUTE } from "@/routing/app-routes";
import { useNavigate } from "react-router-dom";
import useWorkspaceId from "@/hooks/use-workspace-id/useWorkspaceId";
import composeRoute from "@/api/routes/utils/route-utils/route-utils";

const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { workspaceId } = useWorkspaceId();
  const route = workspaceId
    ? composeRoute(HOME_ROUTE, [workspaceId])
    : LOGIN_ROUTE;

  return (
    <div className={`${styles.notFoundPage} flex center align-center`}>
      <div
        className={`${styles.messageContainer} flex column center align-center`}
      >
        <div className={`${styles.primaryMessage} mb-2`}>
          {t("pageNotFound")}
        </div>
        <div className={`${styles.secondaryMessage} mb-8`}>
          {t("couldNotFindPage")}
        </div>
        <div className="one-quarter">
          <PrimaryButton
            onClick={() => navigate(route)}
            text={t("backToHome")}
          />
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
